export const USER_QUESTS = {
  USER_QUESTS: 'USER_QUESTS',
  USER_QUESTS_HISTORY: 'USER_QUESTS_HISTORY',
}
